export function initCheckResultForm() {
  const microReportForm = document.querySelector('[data-micro-report-form]');
  if (microReportForm) {
    const comment = microReportForm.querySelector('[data-micro-report-comment]');
    const results = microReportForm.querySelectorAll('[data-micro-report-result]');
    const continueButton = microReportForm.querySelector('[data-micro-report-continue]');
    const tooltip = microReportForm.querySelector('[data-micro-report-continue-tooltip]');
    const nextSteps = microReportForm.querySelector('[data-micro-report-next-steps]');
    const updateContinueButton = () => {
      const commentText = comment.value.trim();
      const template = (comment.dataset.commentTemplate ?? '').trim();
      const needsCommentEdit = Boolean(commentText) && commentText === template;
      const needsComment = !commentText || needsCommentEdit;
      const needsResult = !Array.from(results).some((result) => result.checked);
      continueButton.disabled = needsComment || needsResult;

      if (continueButton.disabled) {
        tooltip.title = needsCommentEdit
          ? 'Edit the section comment and select a result before continuing.'
          : 'Enter a comment and select a result before continuing.';
      } else {
        tooltip.removeAttribute('title');
      }

      if (nextSteps) {
        const failedResult = Array.from(results).some((result) => result.checked && result.value === 'fail');
        nextSteps.classList.toggle('d-none', !failedResult);
      }
    };

    comment.addEventListener('input', updateContinueButton);
    results.forEach((result) => result.addEventListener('change', updateContinueButton));
    updateContinueButton();
  }

  const form = document.querySelector('.check-result-form');
  if (!form) return;

  const failedResult = form.querySelector('input[name="check_result[result]"][value="fail"]');
  const nextSteps = form.querySelector('.js-troubleshooter-next-steps');
  const comment = form.querySelector('.js-troubleshooter-comment');
  const showComment = form.querySelector('.js-show-troubleshooter-comment');

  if (failedResult) {
    const updateFailureSections = () => {
      if (nextSteps) {
        nextSteps.classList.toggle('d-none', !failedResult.checked);
      } else if (comment) {
        comment.classList.toggle('d-none', !failedResult.checked);
      }
    };
    form.querySelectorAll('input[name="check_result[result]"]').forEach((input) => {
      input.addEventListener('change', updateFailureSections);
    });
    updateFailureSections();
  }

  if (showComment && comment) {
    showComment.addEventListener('click', () => {
      comment.classList.remove('d-none');
      comment.querySelector('textarea')?.focus();
    });
  }

}
